module.exports = __webpack_public_path__ + "static/img/WELLAND.dbe784f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/WELLAND.jpg
// module id = MCi1
// module chunks = 0